import {deserialize, serialize, inheritSerialization, deserializeAs} from "cerialize";
import BaseEntity from "./BaseEntity";
import GroupWhatApps from "./GroupWhatApps";

@inheritSerialization(BaseEntity)
export default class Configuration extends BaseEntity {

    @serialize
    @deserialize
    public formulir: boolean = false;

    @serialize
    @deserialize
    public pembayaran: boolean = false;

    @serialize
    @deserialize
    public uang_saku: boolean = false;

    @serialize
    @deserialize
    public wakaf: boolean = false;

    @serialize
    @deserialize
    public url_panduan: string = "";

    @serialize
    @deserialize
    public admin_bank: number = 0;

    @serialize
    @deserialize
    public admin_fee: number = 0;

    @serialize
    @deserialize
    public bank_accounts: string[] = [];

    @serialize
    @deserialize
    public uang_sakus: string[] = [];

    @serialize
    @deserialize
    public top_up: number[] = [];

    @serialize
    @deserialize
    public wakafs: number[] = [];

    @serialize
    @deserializeAs(GroupWhatApps)
    public groups: Array<GroupWhatApps> = [];

    @serialize
    @deserialize
    public versi: string = "Versi 0.0.2";

    public static OnSerialized(instance: Configuration, json: any): void {
        if (parseInt(json.id) === 0) {
            delete json.id;
        }
    }
}
